














































import { Component, Emit, Prop } from 'vue-property-decorator';

import VueMultiselect from 'vue-multiselect';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { find } from 'lodash';
import useTransactionParticipantModal from '@/mixins/useModal';
import CreditorModal from '@/components/TransactionParticipantModal.vue';
import { formatMoney } from '@/utils/format';
import { BankAccount } from '@/api/payment-orders';

@Component({
  name: 'PaymentOrderTransaction',
  components: {
    VueMultiselect,
    CreditorModal,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class PaymentOrderTransaction extends useTransactionParticipantModal {
  @Prop({
    type: String,
    default: null,
  })
  readonly creditorId!: string;

  @Prop({
    type: Number,
    required: true,
  })
  readonly amount!: number;

  @Prop({
    type: String,
    required: true,
  })
  readonly model!: string;

  @Prop({
    type: String,
    required: true,
  })
  readonly beneficiaryRef!: string;

  @Prop({
    type: String,
    required: true,
  })
  readonly additionalInfo!: string;

  @Prop({
    type: Array,
    default: () => [],
  })
  readonly creditors!: BankAccount[];

  get creditorComputed(): BankAccount {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.findCreditorById(this.creditorId)!;
  }

  get creditorTitle() {
    return `${this.creditorComputed.name} (${this.creditorComputed.iban})`;
  }

  get amountComputed() {
    return `${formatMoney(this.amount)} EUR`;
  }

  findCreditorById(id: string | null) {
    if (id === null) {
      return null;
    }

    return find(this.creditors, ['id', id]) || null;
  }

  @Emit('transaction:edit')
  onTransactionEdit() {
    return false;
  }

  @Emit('transaction:delete')
  onTransactionDelete() {
    return false;
  }
}

